
        var result = require("!!../../../../node_modules/css-loader/index.js!./whitelabels.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/whitelabels/whitelabels.component.css
// module id = 702
// module chunks = 0